import { connect } from 'react-redux';
import CustomModal from './Modal';

const mapStateToProps = ({ modal: { isModalOpen, options } }) => ({
    isModalOpen,
    modalOptions: options
});

export default connect(mapStateToProps)(CustomModal);
